import React, {Component} from 'react';
import { Row } from "react-bootstrap";

export default class Header extends Component{
    constructor(props) {
        super(props);
	}
	
    render(){

        return(
            <Row>
				<div className="header col col-md-12 col-sm-12 col-xs-12"> 
                  <span className="">{this.props.title}</span>
				</div>
			</Row>
		);
    }
}